// extracted by mini-css-extract-plugin
export default {"inputbox":"inputbox_inputbox__nU1aS","form":"inputbox_form__ZbdRl"};